export default __webpack_public_path__ + "static/media/restaurantDesktop.9b3b2451.jpg";